export const vehicles = {
  title: 'إدارة المركبات',
  subtitle: 'إدارة أسطول المركبات الخاص بك',
  
  // Actions
  addVehicle: 'إضافة مركبة',
  addFirstVehicle: 'أضف مركبتك الأولى',
  editVehicle: 'تعديل المركبة',
  deleteVehicle: 'حذف المركبة',
  viewDetails: 'عرض التفاصيل',
  addLocation: 'إضافة موقع',
  locationManagement: 'إدارة المواقع',
  
  // Status
  available: 'متاح',
  rented: 'مؤجر',
  maintenance: 'صيانة',
  
  // Form fields
  make: 'الماركة',
  model: 'الموديل',
  year: 'السنة',
  color: 'اللون',
  category: 'الفئة',
  transmission: 'ناقل الحركة',
  fuelType: 'نوع الوقود',
  seats: 'المقاعد',
  pricePerDay: 'السعر في اليوم',
  features: 'المميزات',
  description: 'الوصف',
  images: 'الصور',
  location: 'موقع المركبة',
  selectLocation: 'اختر موقعاً',
  selectLocations: 'اختر المواقع',
  locationRequired: 'يرجى اختيار موقع واحد على الأقل',
  
  // Table headers
  image: 'الصورة',
  availability: 'متاح',
  pricePerDayShort: 'السعر/يوم',
  statusHeader: 'الحالة',
  
  // Column settings
  columnSettings: 'إعدادات الأعمدة',
  basicInformation: 'المعلومات الأساسية',
  vehicleDetails: 'تفاصيل المركبة',
  maintenanceLegal: 'الصيانة والشؤون القانونية',
  systemInformation: 'معلومات النظام',
  
  // Bulk actions
  bulkActions: 'إجراءات',
  markAsAvailable: 'وضع علامة متاح',
  markAsRented: 'وضع علامة مؤجر',
  markAsMaintenanceShort: 'وضع علامة قيد الصيانة',
  exportCsv: 'تصدير CSV',
  
  // Messages
  vehicleSelectedCount: '{{count}} مركبة محددة',
  vehicleDeletedSuccessfully: 'تم حذف المركبة بنجاح',
  vehicleDeletedDesc: 'تم إزالة المركبة من أسطولك.',
  failedToDeleteVehicle: 'فشل في حذف المركبة',
  vehiclesDeletedSuccessfully: 'تم حذف {{count}} مركبة',
  vehiclesDeletedDesc: 'تم حذف المركبات المحددة بنجاح.',
  vehiclesStatusUpdated: 'تم وضع علامة على {{count}} مركبة كـ {{status}}',
  vehiclesStatusUpdatedDesc: 'تم تحديث حالة المركبات المحددة.',
  vehiclesExported: 'تم تصدير {{count}} مركبة',
  vehiclesExportedDesc: 'تم تصدير بيانات المركبة إلى CSV.',
  errorOccurred: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  statusUpdatedSuccessfully: 'تم تحديث حالة المركبة',
  statusUpdatedDesc: 'تم تحديث حالة المركبة بنجاح.',
  failedToUpdateStatus: 'فشل في تحديث حالة المركبة',
  failedToUpdateStatusDesc: 'حدث خطأ أثناء تحديث حالة المركبة.',
  
  // Empty states
  noVehiclesFound: 'لا توجد مركبات',
  noVehiclesFoundDesc: 'جرب تعديل معايير البحث أو المرشحات لرؤية المزيد من النتائج.',
  
  // Registration number
  registrationNumber: 'رقم التسجيل',
  registrationRequired: 'رقم التسجيل مطلوب',
  registrationInvalid: 'يجب أن يحتوي رقم التسجيل على أكثر من 3 أحرف',
  
  // Image upload
  vehicleImages: 'صور المركبة (الحد الأقصى 6)',
  clickToAddImages: 'اضغط لإضافة الصور',
  dragDropImages: 'أو اسحب وأسقط صورك هنا',
  imageFormats: 'PNG، JPG حتى 6 صور',
  addImageButton: 'إضافة',
  
  // Features
  featuresAndOptions: 'المميزات والخيارات',
  addAll: 'إضافة الكل',
  noFeaturesSelected: 'لم يتم اختيار أي مميزات',
  clickToAddQuickly: 'اضغط للإضافة السريعة:',
  enterFeature: 'أدخل اسم الميزة',
  
  // Features list
  featuresList: {
    airConditioning: 'تكييف الهواء',
    powerSteering: 'التوجيه المعزز',
    centralLocking: 'القفل المركزي',
    electricWindows: 'النوافذ الكهربائية',
    radio: 'راديو',
    gpsNavigation: 'نظام تحديد المواقع/الملاحة',
    bluetooth: 'بلوتوث',
    backupCamera: 'كاميرا للرجوع للخلف',
    parkingSensors: 'أجهزة استشعار الوقوف',
    heatedSeats: 'مقاعد مُدفئة',
    sunroof: 'فتحة سقف',
    alloyWheels: 'عجلات من السبائك',
    ledHeadlights: 'مصابيح LED',
    cruiseControl: 'التحكم في السرعة',
    premiumAudio: 'نظام صوتي متميز',
    usbAux: 'USB/AUX',
    keylessStart: 'بدء التشغيل بدون مفتاح',
    sideAirbags: 'وسائد هوائية جانبية',
    abs: 'نظام ABS',
    esp: 'نظام ESP',
    brakeAssist: 'مساعد الفرملة',
    blindSpotDetection: 'كشف النقطة العمياء',
    laneAssist: 'تحذير الخروج من المسار',
    heatedWindshield: 'الزجاج الأمامي المُدفأ',
    electricMirrors: 'المرايا الكهربائية'
  },
  
  // Maintenance
  maintenanceInformation: 'معلومات الصيانة',
  registrationNumberRequired: 'رقم التسجيل *',
  currentMileage: 'المسافة المقطوعة الحالية',
  insuranceExpiry: 'انتهاء التأمين',
  insuranceExpiryShort: 'انتهاء التأمين',
  technicalControlExpiry: 'انتهاء الفحص الفني',
  technicalControlExpiryShort: 'انتهاء الفحص الفني',
  circulationPermitExpiry: 'انتهاء تصريح التداول',
  circulationPermitExpiryShort: 'انتهاء تصريح التداول',
  oilChangeDueDate: 'تغيير الزيت التالي',
  lastOilChange: 'آخر تغيير زيت',
  lastOilChangeShort: 'آخر تغيير زيت',
  lastOilChangeMileage: 'المسافة المقطوعة عند آخر تغيير زيت',
  lastOilChangeMileageShort: 'كم آخر تغيير زيت',
  oilChangeInterval: 'فترة تغيير الزيت (كم)',
  oilChangeIntervalShort: 'فترة تغيير الزيت (كم)',
  maintenanceNotes: 'ملاحظات الصيانة',
  maintenanceNotesShort: 'ملاحظات الصيانة',
  
  // System fields
  createdAt: 'تاريخ الإنشاء',
  updatedAt: 'آخر تعديل',
  actions: 'إجراءات',
  
  // Color search
  searchColor: 'اكتب للبحث عن لون...',
  
  // Brand and model search
  searchBrand: 'اكتب للبحث عن ماركة...',
  selectModel: 'اختر موديل...',
  selectBrandFirst: 'اختر الماركة أولاً',
  
  // Error messages
  correctErrors: 'يرجى تصحيح الأخطاء التالية:',
  yearInvalid: 'يجب أن تكون السنة بين 1900 و 2030',
  seatsInvalid: 'يجب أن يكون عدد المقاعد بين 1 و 15',
  mileageInvalid: 'لا يمكن أن تكون المسافة المقطوعة سالبة',
  oilChangeMileageInvalid: 'لا يمكن أن تكون المسافة المقطوعة عند آخر تغيير زيت سالبة',
  oilChangeMileageGreaterThanCurrent: 'لا يمكن أن تكون المسافة المقطوعة عند آخر تغيير زيت أكبر من المسافة المقطوعة الحالية',
  oilChangeIntervalInvalid: 'يجب أن تكون فترة تغيير الزيت 1000 كم على الأقل',
  oilChangeDateInvalid: 'لا يمكن أن يكون تاريخ آخر تغيير زيت في المستقبل',
  failedToUploadImage: 'فشل في تحميل الصورة {{fileName}}: {{error}}',
  
  // Form actions
  clearAll: 'مسح الكل',
  clearForm: 'مسح النموذج',
  clearFormMessage: 'هل أنت متأكد من أنك تريد مسح جميع بيانات النموذج؟ لا يمكن التراجع عن هذا الإجراء.',
  
  // Validation messages
  makeRequired: 'الماركة مطلوبة',
  modelRequired: 'الموديل مطلوب',
  colorRequired: 'اللون مطلوب',
  categoryRequired: 'الفئة مطلوبة',
  transmissionRequired: 'نوع ناقل الحركة مطلوب',
  fuelTypeRequired: 'نوع الوقود مطلوب',
  priceRequired: 'السعر في اليوم مطلوب',
  
  // Categories
  categories: {
    economy: 'اقتصادية',
    compact: 'مدمجة',
    midsize: 'متوسطة الحجم',
    fullsize: 'كبيرة الحجم',
    luxury: 'فاخرة',
    suv: 'رياضية متعددة الاستخدامات',
    convertible: 'قابلة للتحويل',
  },
  
  // Transmission types
  automatic: 'أوتوماتيك',
  manual: 'يدوي',
  
  // Fuel types
  fuelTypes: {
    gasoline: 'بنزين',
    diesel: 'ديزل',
    hybrid: 'هجين',
    electric: 'كهربائي',
    lpg: 'غاز البترول المسال',
  },
  
  // Status labels
  status: {
    available: 'متاح',
    rented: 'مؤجر',
    maintenance: 'صيانة',
  },
  
  // Messages
  noVehicles: 'لا توجد مركبات',
  noVehiclesDesc: 'أضف مركبتك الأولى لبدء إدارة أسطولك.',
  totalVehicles: 'تم العثور على {{count}} مركبة',
  vehicleAdded: 'تم إضافة المركبة بنجاح',
  vehicleUpdated: 'تم تحديث المركبة بنجاح',
  vehicleDeleted: 'تم حذف المركبة بنجاح',
  failedToAdd: 'فشل في إضافة المركبة',
  failedToUpdate: 'فشل في تحديث المركبة',
  permissionDenied: 'تم رفض الإذن. تأكد من وجود إذن لإدارة المركبات لهذه الوكالة.',
  duplicateError: 'توجد مركبة بهذه المعلومات بالفعل. يرجى التحقق من رقم التسجيل أو الحقول الأخرى الفريدة.',
  constraintError: 'بيانات غير صالحة. يرجى التحقق من جميع الحقول المطلوبة.',
  networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
  
  // Actions
  delete: 'حذف',
  deleteAll: 'حذف الكل',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  deleteConfirmTitle: 'حذف المركبة',
  deleteConfirmMessage: 'هل أنت متأكد من أنك تريد حذف هذه المركبة؟ هذا الإجراء لا يمكن التراجع عنه.',
  deleteAllConfirmTitle: 'حذف المركبات المحددة',
  deleteAllConfirmMessage: 'هل أنت متأكد من أنك تريد حذف {{count}} مركبة المحددة؟ هذا الإجراء لا يمكن التراجع عنه.',
  
  // Filters
  allCategories: 'جميع الفئات',
  allTransmissions: 'جميع أنواع ناقل الحركة',
  allStatuses: 'جميع الحالات',
  searchPlaceholder: 'البحث بالماركة أو الموديل أو السنة...',
  
  // Placeholders
  selectDate: 'اختر التاريخ',
  enterRegistrationNumber: 'مثال: ABC-123-45 (مطلوب)',
  enterMileage: 'مثال: 50000',
  enterLastServiceMileage: 'مثال: 45000',
  enterMaintenanceNotes: 'ملاحظات الصيانة والإصلاحات وما إلى ذلك...',
}; 